// extracted by mini-css-extract-plugin
export default {"root":"EditableTitle_root__u1+sm","name":"EditableTitle_name__giDjq"};